import apiClient from "./apiClient";
import {
  EmailTrackingDashboardResponse,
  EmailTrackingQueryParams,
} from "../types/email-tracking.types";

/**
 * Fetch Email Tracking Dashboard data
 * Endpoint: GET /grants/admin/email-tracking?from=ISO8601&to=ISO8601
 */
export const getEmailTrackingDashboard = async (
  params?: EmailTrackingQueryParams
): Promise<EmailTrackingDashboardResponse> => {
  const searchParams = new URLSearchParams();
  if (params?.from) searchParams.append("from", params.from);
  if (params?.to) searchParams.append("to", params.to);

  const queryString = searchParams.toString();
  const url = `/grants/admin/email-tracking${queryString ? `?${queryString}` : ""}`;

  const { data } = await apiClient.get<EmailTrackingDashboardResponse>(url);
  return data;
};
